import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EmpadronamientoCard } from "../UI/EmpadronamientoCard";
import { EmpadronamientoDetalleSolicitudDocumentacion } from "./EmpadronamientoDetalleSolicitudDocumentacion";
import { getPatologiasEmp, postSolicitud, setActiveStep, setSolicitud } from "../../../actions/empadronamiento/Empadronamiento";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import { STEPPER_EMPADRONAMIENTO } from "../../../utils/constants";

export const EmpadronamientoDetalleDocumentacion = () => {
  const { solicitudSeleccionada = {}, patologiasEmpadronamiento } = useSelector(
    (state) => state.empadronamiento
  );
  const dispatch = useDispatch();
  const [idPatologia, setIdPatologia] = useState(solicitudSeleccionada?.idPatologia ?? 0);

  let idTipoEmpadronamiento;

  if (solicitudSeleccionada != null) {
    idTipoEmpadronamiento = solicitudSeleccionada?.idTipoEmpadronamiento;
  }
  console.log(solicitudSeleccionada)
  useEffect(() => {
    dispatch(getPatologiasEmp(idTipoEmpadronamiento))
  }, [dispatch]);

  const handleChange = (event) => {
    const newPatologiaId = event.target.value;
    setIdPatologia(newPatologiaId);

    const data = {
      ...solicitudSeleccionada,
      idPatologia: newPatologiaId
    }
    dispatch(postSolicitud(data, null, null, false, setActiveStep, STEPPER_EMPADRONAMIENTO.DOCUMENTACION))
    dispatch(setSolicitud(data));
    
  };
  console.log(idPatologia)
  return (
    <>

      <EmpadronamientoCard width={"55%"}>
        <Grid item xs={8} style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin:'0 auto',
          marginTop:'1rem',
          marginBottom:'2rem'
        }}>
          <FormControl fullWidth>
            <InputLabel id="select-patologia-label">Patologia</InputLabel>
            <Select
              labelId="select-patologia-label"
              id="select-patologia"
              value={idPatologia}
              onChange={handleChange}
              label="Patologia"
            >
              {patologiasEmpadronamiento.map((patologia) => (
                <MenuItem key={patologia.idPatologia} value={patologia.idPatologia}>
                  {patologia.descripcion}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <EmpadronamientoDetalleSolicitudDocumentacion
          idTipoEmpadronamiento={idTipoEmpadronamiento}
          idPatologia={idPatologia}
        />
      </EmpadronamientoCard >
    </>

  );
};
